<template>
  <div>
    <v-dialog v-model="model" class="tw-max-w-[630px] tw-w-full custom-dialog">
      <v-card class="tw-w-full tw-h-screen">
        <div class="tw-mx-4 tw-my-2">
          <div class="tw-w-full tw-flex tw-justify-end">
            <v-icon
              @click="$emit('toggleRequestOrder')"
              size="26px"
              class="tw-ml-[2px] !tw-text-black tw-cursor-pointer"
              icon=" fa fa-close"
            ></v-icon>
          </div>
          <v-form ref="formRef" v-model="formDetails.valid">
            <div class="tw-mx-4 tw-my-4">
              <h2
                class="tw-font-kanit tw-font-bold tw-text-4xl tw-text-black tw-text-center tw-w-full"
              >
                Reserve Custom Order
              </h2>
              <div class="tw-my-4 tw-flex sm:tw-gap-10 tw-flex-wrap sm:tw-flex-nowrap tw-mt-6">
                <div class="tw-w-full sm:tw-w-1/2">
                  <img class="tw-w-full sm:tw-w-full" :src="carDetails.imageURL" alt="Car Image" />
                </div>
                <div class="tw-w-full sm:tw-w-1/2">
                  <div
                    class="tw-font-kanit tw-font-extralight tw-flex tw-justify-between tw-gap-3 tw-items-start"
                  >
                    <h3 class="tw-max-w-56">
                      {{ selectedYear }} {{ selectedMake.name }} {{ carDetails.styleName }}
                      {{ carDetails.subStyleName }}
                    </h3>
                    <p class="tw-text-xs tw-mt-1">${{ carDetails.baseMSRP.toLocaleString() }}</p>
                  </div>
                  <div class="tw-max-h-40 tw-overflow-y-scroll tw-pr-3">
                    <div
                      v-for="detail in carSelectedDetails"
                      :key="detail"
                      class="tw-font-kanit tw-font-extralight tw-flex tw-justify-between tw-gap-3 tw-items-start tw-mt-3"
                    >
                      <h3 class="tw-max-w-56 tw-text-xs">
                        {{ detail.descriptions[0].description }}
                      </h3>
                      <p class="tw-text-xs tw-mt-1">${{ detail.msrp.toLocaleString() }}</p>
                    </div>
                  </div>
                  <div
                    class="tw-font-kanit tw-font-extralight tw-flex tw-justify-between tw-gap-3 tw-items-start tw-mt-2"
                  >
                    <h3 class="tw-max-w-56 tw-text-xs">Destination Charge</h3>
                    <p class="tw-text-xs tw-mt-1">${{ carDetails.destination.toLocaleString() }}</p>
                  </div>
                  <div
                    class="tw-font-kanit tw-font-extralight tw-flex tw-justify-between tw-gap-3 tw-items-start tw-mt-1 tw-uppercase"
                  >
                    <h3 class="tw-max-w-56 tw-">Total</h3>
                    <p class="tw-mt-1">${{ carDetails.totalMSRP.toLocaleString() }}</p>
                  </div>
                </div>
              </div>
              <div class="tw-flex tw-flex-wrap">
                <div class="tw-w-full sm:tw-w-1/2 tw-pr-0 tw-mb-2 sm:tw-pr-6">
                  <v-text-field
                    label="First Name *"
                    class="tw-font-kanit tw-text-xs"
                    :class="['custom-input-field']"
                    v-model="formDetails.firstName"
                    :rules="formDetails.firstNameRules"
                    required
                    variant="outlined"
                  ></v-text-field>
                </div>
                <div class="tw-w-full sm:tw-w-1/2 tw-mb-2">
                  <v-text-field
                    label="Last Name *"
                    class="tw-font-kanit tw-text-xs"
                    :class="['custom-input-field']"
                    v-model="formDetails.lastName"
                    :rules="formDetails.lastNameRules"
                    required
                    variant="outlined"
                  ></v-text-field>
                </div>
                <div class="tw-w-full sm:tw-w-1/2 tw-pr-0 sm:tw-pr-6">
                  <v-text-field
                    label="Email *"
                    class="tw-font-kanit tw-text-xs"
                    :class="['custom-input-field']"
                    v-model="formDetails.email"
                    :rules="formDetails.emailRules"
                    required
                    variant="outlined"
                  ></v-text-field>
                </div>
                <div class="tw-w-full sm:tw-w-1/2">
                  <v-text-field
                    label="Phone"
                    class="tw-font-kanit tw-text-xs"
                    :class="['custom-input-field']"
                    v-model="formDetails.phone"
                    variant="outlined"
                  ></v-text-field>
                </div>
              </div>
              <div>
                <h3 class="tw-font-kanit tw-text-zinc-500 tw-pl-1 tw-mb-3">Order Type *</h3>

                <v-radio-group v-model="formDetails.orderType">
                  <v-radio
                    class="custom-radio-btn tw-capitalize tw-mb-1 tw-text-zinc-400 tw-flex tw-items-center tw-px-3 tw-text-xs hover:tw-text-black tw-border tw-border-[#e6e6e6] tw-min-h-9 hover:tw-bg-[#e7e7e7] hover:tw-border-black tw-cursor-pointer"
                    density="compact"
                    color="primary"
                    :ripple="false"
                    value="wait list"
                    label="wait list"
                  ></v-radio>

                  <v-radio
                    density="compact"
                    :ripple="false"
                    color="primary"
                    class="custom-radio-btn tw-capitalize tw-text-zinc-400 tw-flex tw-items-center tw-px-3 tw-text-xs hover:tw-text-black tw-border tw-border-[#e6e6e6] tw-min-h-9 hover:tw-bg-[#e7e7e7] hover:tw-border-black tw-cursor-pointer"
                    label="$250 deposit"
                    value="250"
                  ></v-radio>
                </v-radio-group>
              </div>
              <div>
                <h3 class="tw-font-kanit tw-text-zinc-500 tw-pl-1 tw-mb-3">Disclaimer *</h3>
                <v-checkbox
                  class="custom-checkbox tw-font-kanit"
                  :ripple="false"
                  v-model="formDetails.disclaimer"
                  required
                  :rules="formDetails.disclaimerRules"
                  label=" Your Online Order Reservation places your interest to the dealership. It is not a purchase or order placement. Completion of this form does not guarantee you a vehicle delivery or a specified price."
                  color="primary"
                ></v-checkbox>
              </div>
              <div class="tw-w-full tw-flex tw-justify-center tw-my-14">
                <div
                  @click="submitForm"
                  class="tw-h-11 tw-max-w-60 tw-w-full tw-bg-[#007cc0] tw-border-2 tw-border-[#007cc0] tw-flex tw-items-center tw-justify-center tw-uppercase tw-font-kanit tw-text-sm tw-font-extralight tw-rounded-full tw-text-white tw-cursor-pointer hover:tw-bg-white hover:tw-text-[#007cc0] tw-transition-all tw-duration-150 tw-select-none"
                >
                  Send
                </div>
              </div>
            </div>
          </v-form>
          <p class="tw-font-kanit tw-text-[8px] tw-font-extralight tw-italic tw-text-center">
            *Your Online Order Reservation places your interest to the dealership. It is not a
            purchase or order placement. Completion of this form does not guarantee you a vehicle
            delivery or a specified price.
          </p>
        </div>
        <div class="tw-bg-black tw-text-center tw-w-full">
          <p class="tw-font-kanit tw-text-xs tw-font-light tw-text-white tw-p-3">
            Need help? Call (866) 529-3555
          </p>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useCarsStore } from '@/stores/useCarsStore';
import { storeToRefs } from 'pinia';
const carStore = useCarsStore();
const { carDetails, selectedMake, selectedYear, carSelectedDetails } = storeToRefs(carStore);
const formRef = ref(null);
const model = defineModel();
const formDetails = reactive({
  valid: false,
  firstName: '',
  lastName: '',
  firstNameRules: [
    (value) => {
      if (value) return true;
      return 'First Name is required.';
    },
  ],
  lastNameRules: [
    (value) => {
      if (value) return true;
      return 'Last Name is required.';
    },
  ],
  email: '',
  emailRules: [
    (value) => {
      if (value) return true;

      return 'E-mail is required.';
    },
    (value) => {
      if (/.+@.+\..+/.test(value)) return true;

      return 'E-mail must be valid.';
    },
  ],
  phone: '',
  disclaimer: false,
  disclaimerRules: [
    (value) => {
      if (value) return true;
      return 'Disclaimer is required.';
    },
  ],
  orderType: 'wait list',
});

const submitForm = async () => {
  // Validate the form
  const { valid } = await formRef.value.validate();

  // If form is not valid, stop submission
  if (!valid) {
    return;
  }

  // Log the form details (instead of API submission)
  console.log('Form Submitted', {
    firstName: formDetails.firstName,
    lastName: formDetails.lastName,
    email: formDetails.email,
    phone: formDetails.phone,
    orderType: formDetails.orderType,
  });

  // Reset the form
  resetForm();
};

// Helper function to reset form
const resetForm = () => {
  formRef.value.reset();
  formDetails.firstName = '';
  formDetails.lastName = '';
  formDetails.email = '';
  formDetails.phone = '';
  formDetails.orderType = 'wait list';
  formDetails.disclaimer = false;
};
</script>

<style>
.custom-input-field .v-field {
  @apply !tw-rounded-none !tw-text-xs;
}

.custom-input-field .v-field__outline {
  color: #aeadad !important;
}
/* .custom-border .v-field--focused .v-field__outline {
  color: green !important;
} */
.custom-dialog .v-card {
  @apply !tw-rounded-none !tw-shadow-none;
}
.custom-dialog .v-overlay__scrim {
  background-color: rgba(0, 0, 0, 0.75) !important;
}
.custom-dialog .v-overlay__content {
  max-height: calc(100% - 0px) !important;
  max-width: calc(100% - 0px) !important;
  width: calc(100% - 0px) !important;
}
.custom-radio-btn .v-label {
  @apply !tw-text-xs tw-text-zinc-600 !tw-font-kanit;
}
.custom-checkbox {
  @apply tw-text-[10px];
}
.custom-checkbox .v-label {
  @apply !tw-font-kanit !tw-text-[11px] tw-pl-2 tw-pr-10;
}
</style>
